import axios, { AxiosResponse } from 'axios';

const TIMEOUT = 30000;

export const MIVA_SERVICE_ENDPOINT =
  process.env.REACT_APP_MIVA_SERVICE_ENDPOINT ||
  'https://metrics.staging.miva.university';

export const MIVA_BACKOFFICE_API_KEY =
  process.env.REACT_APP_MIVA_BACKOFFICE_X_API_KEY || 'x-api-key';

const baseApi = axios.create({
  baseURL: MIVA_SERVICE_ENDPOINT,
  timeout: TIMEOUT, // Set a timeout
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': MIVA_BACKOFFICE_API_KEY,
  },
});

// Request interceptor
baseApi.interceptors.request.use(
  async (config) => {
    return config;
  },
  (error) => {
    // Handle request error
    return Promise.reject(error);
  }
);

// Response interceptor
baseApi.interceptors.response.use(
  (response: AxiosResponse<AxiosResponse<any>>) => {
    if (response.data && response.data.data) {
      response.data = response.data.data;
    }

    return response;
  },
  (error) => {
    // Handle response error
    if (error.response) {
      // The request was made, but the server responded with a status code
      // that falls out of the range of 2xx
      console.error('Response error:', error.response.data);
      console.error('Status code:', error.response.status);
    } else if (error.request) {
      // The request was made, but no response was received
      console.error('No response received:', error.request);
    } else {
      console.error('Request setup error:', error.message);
    }

    return Promise.reject(error);
  }
);

export { baseApi };
